<template>
	<div class="form-group mod">
		<label :for="id" class="form-label" :class="{'require' : required}">
			{{ title }}
		</label>
		<textarea class="form-control"
		       :id="id"
		       :placeholder="placeholder"
		       v-model="value"
		       @keyup="doRegex"
		       @input="$emit('input', value)"
		></textarea>
	</div>
</template>

<script>
export default {
	name: "SOInputTextarea",
	props: {
		title: String,
		id: String,
		placeholder: String,
		value: String,
		validation: String,
		required: Boolean,
	},
	data() {
		return {
			regexType: {
				alphanumeric: new RegExp(/[#@!$\\%^&*()_+|~=`{}\[\]:";<>?\/]*$/g),
				email: new RegExp(/[,#!$\\%^&*()+|~=`{}\[\]:";<>?\/]*$/g),
				emoji: /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g,
			},
		}
	},
	watch: {
		value: {
			handler: function () {
				this.doRegex()
			}
		}
	},
	methods: {
		doRegex() {
			if (this.validation === "") {
				this.validation = 'alphanumeric'
			}
			let regexType = this.regexType[this.validation]
			this.value = this.value.replace(regexType, "");
			this.value = this.value.replace(this.regexType.emoji, "");
			this.$emit('input', this.value)
		},
	}
}
</script>